"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("whatwg-fetch");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FetchHelper =
/*#__PURE__*/
function () {
  function FetchHelper() {
    _classCallCheck(this, FetchHelper);
  }

  _createClass(FetchHelper, null, [{
    key: "get",
    value: function get(url, options) {
      options.method = 'GET';
      return fetch(url, options).then(this.handleResponse);
    }
  }, {
    key: "getBlob",
    value: function getBlob(url, options) {
      options.method = 'GET';
      return fetch(url, options).then(this.handleBlobResponse);
    }
  }, {
    key: "post",
    value: function post(url, options) {
      options.method = 'POST';

      if (_typeof(options.body) === 'object' && !(options.body instanceof FormData)) {
        options.body = JSON.stringify(options.body);
      }

      return fetch(url, options).then(this.handleResponse);
    }
  }, {
    key: "patch",
    value: function patch(url, options) {
      options.method = 'PATCH';

      if (_typeof(options.body) === 'object') {
        options.body = JSON.stringify(options.body);
      }

      return fetch(url, options).then(this.handleResponse);
    }
  }, {
    key: "put",
    value: function put(url, options) {
      options.method = 'PUT';

      if (_typeof(options.body) === 'object') {
        options.body = JSON.stringify(options.body);
      }

      return fetch(url, options).then(this.handleResponse);
    }
  }, {
    key: "delete",
    value: function _delete(url, options) {
      options.method = 'DELETE';

      if (_typeof(options.body) === 'object') {
        options.body = JSON.stringify(options.body);
      }

      return fetch(url, options).then(this.handleResponse);
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      return response.text().then(function (text) {
        var data = text && JSON.parse(text);

        if (!response.ok) {
          return Promise.reject({
            error: new Error(response.status + ": " + response.statusText),
            httpStatus: response.status,
            response: data
          });
        }

        return Promise.resolve(data);
      });
    }
  }, {
    key: "handleBlobResponse",
    value: function handleBlobResponse(response) {
      return response.blob().then(function (blob) {
        if (!response.ok) {
          return Promise.reject(response);
        }

        return Promise.resolve(blob);
      });
    }
  }]);

  return FetchHelper;
}();

exports["default"] = FetchHelper;
;